import React from 'react';
import { MapPin, Search, Tag, CheckCircle } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const steps = [
  {
    id: 'step-1',
    number: '01',
    icon: MapPin,
    title: 'Enter your pin code',
    description: 'Simply enter your pin code to let OFY find the best local offers in your area. No GPS needed — just your pin code.',
    color: 'from-rose-50 to-orange-50',
    iconColor: 'text-primary',
  },
  {
    id: 'step-2',
    number: '02',
    icon: Search,
    title: 'Discover nearby offers',
    description: 'Browse hundreds of verified deals from restaurants, salons, gyms, retail shops and more — all near you.',
    color: 'from-orange-50 to-amber-50',
    iconColor: 'text-accent',
  },
  {
    id: 'step-3',
    number: '03',
    icon: Tag,
    title: 'Claim and save',
    description: 'Tap any offer, show it at the store, and save instantly. No coupons, no printing — just your phone.',
    color: 'from-amber-50 to-yellow-50',
    iconColor: 'text-yellow-500',
  },
  {
    id: 'step-4',
    number: '04',
    icon: CheckCircle,
    title: 'Enjoy & repeat',
    description: 'New offers from your favorite local businesses drop daily. Come back often to never miss a deal.',
    color: 'from-emerald-50 to-teal-50',
    iconColor: 'text-emerald-500',
  },
];

export default function LandingHowItWorks() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="section-label mb-3">How it works</p>
          <h2 className="text-hero-md text-foreground mb-4">
            Saving locally has never been{' '}
            <span className="gradient-brand-text">this simple</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            From discovery to redemption in under 30 seconds.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps?.map((step) => {
            const Icon = step?.icon;
            return (
              <div key={step?.id} className="relative">
                <div className={`card-elevated rounded-2xl p-6 h-full bg-gradient-to-br ${step?.color} border-0`}>
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-card">
                      <Icon size={22} className={step?.iconColor} />
                    </div>
                    <span className="text-4xl font-extrabold text-foreground/8 leading-none">{step?.number}</span>
                  </div>
                  <h3 className="text-base font-700 font-bold text-foreground mb-2">{step?.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{step?.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}